import React from "react";
import PropTypes from "prop-types";
import styles from "./KeyContactsList.module.css";
import { v4 } from "uuid";

import KeyContactItem from "../KeyContactItem";

/**
 * Interactive component. Displays the key contacts for the key contacts tab on the Event Details page.
 */
export function KeyContactsList({ keyContacts, onEdit }) {
  const _keyContacts = keyContacts.map((contact) => {
    return { ...contact, id: v4() };
  });

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p>Key Contacts</p>
        {onEdit && (
          <button className={styles["button"]} onClick={onEdit}>
            Edit
          </button>
        )}
      </div>
      <div className={styles.content}>
        <div>
          <div className={styles["list-header"]}>
            {/* Functions as header */}
            <KeyContactItem
              contact={{
                position: "Position",
                name: "Name",
                number: "Phone Number",
                email: "Email",
              }}
              index={0}
            />
          </div>
          <ul className={styles["flex-container"]}>
            <li className={styles.flex}>
              {_keyContacts.map((contact, index) => (
                <KeyContactItem
                  key={contact.id}
                  contact={contact}
                  index={index - 1}
                />
              ))}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

KeyContactsList.propTypes = {
  /**
   * Array of key contact objects.
   */
  keyContacts: PropTypes.arrayOf(
    PropTypes.shape({
      position: PropTypes.string,
      name: PropTypes.string,
      number: PropTypes.string,
      email: PropTypes.string,
    })
  ),
  /**
   * Function called when edit is clicked.
   */
  onEdit: PropTypes.func,
};

KeyContactsList.defaultProps = {
  keyContacts: [],
};
